import { Route } from '@angular/router';
import { authGuard } from '@/app/core/auth';

export const routes: Route[] = [
  // Default redirect to admin
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'admin',
  },

  // Auth (public)
  {
    path: 'auth',
    loadChildren: () => import('./domains/auth/routes'),
  },

  // Public registration (no auth required)
  {
    path: 'register',
    loadChildren: () => import('./domains/register/routes'),
  },

  // "View as user" receiver (CLUB-2413) — public: it signs in with a token
  // handed over by the opener tab, so it cannot sit behind the auth guard.
  {
    path: 'view-as',
    loadComponent: () => import('./domains/view-as/view-as'),
  },

  // Admin (protected)
  {
    path: 'admin',
    canActivate: [authGuard],
    loadChildren: () => import('./domains/admin/routes'),
  },

  // Catch all → sign in
  { path: '**', redirectTo: 'auth/sign-in' },
];
